import { lazy } from "react";
import SalesForAutoCare from "./Sales/POS/salesForAutoCare";
import GeneralLedger from "./AccountDetails/GeneralLedger/GeneralLedger";
import JournalTypes from "./AccountDetails/JounralTypesAccount/JournalTypes";
import SupplierReports from "./Reports/ReportsComponents/Supplier";
// import { useSelector } from "react-redux";
// import { authRoles } from "../auth";
// import AutoLogout from "./AutoLogout";

//---------------Dash Board-------------------------------------//
const Dashboard = lazy(() => import("./Dashboard/dashboard"));
//----------End Dash Board--------------------------------------//

//---------------sales------------------------------------------//

const Sales = lazy(() => import("./Sales/POS/sales"));
const Channelling = lazy(() => import("./Sales/POS/channelling"));
const listOfChannelling = lazy(() => import("./Sales/POS/listOfChannelling"));
const SalesForwareHouse = lazy(()=> import("./Sales/POS/salesForWarehouse"));
const Delivery = lazy(()=>import("./Sales/POS/Delivery/delivery"))

//---------------End Sales------------------------------------------------//

//----------------Stock----------------------------------------------------//

//---------------------GRN------------------------------------------------//
//----------------Grn-------------------------------------------------//
const Grn = lazy(() => import("./Store/GRN/grn"));
//----------------End Grn----------------------------------------------------//
//---------------------------Paid-----------------------------------------//
const PaidGrn = lazy(() => import("./Store/GRN/paidGrn"));
//---------------------------End Paid-----------------------------------------//
//----------------------End GRN------------------------------------------------//

//--------------------------Mature Stock-----------------------------------------//
const matureStock = lazy(() => import("./Store/MatureStock/MatureStock"));
//--------------------------End Mature Stock---------------------------------//

//---------------------Transfer---------------------------------------------//
const Transfer = lazy(() => import("./Store/Transfer/stockTransfer"));
//------------------------End Transfer----------------------------------------//

//------------------------Stock In---------------------------------------//
const StockIn = lazy(() => import("./Store/StockIn/StockIn"));
//-------------------------End Stock In---------------------------------------//

//--------------------------Stock Dashboard-----------------------------------------------------//
const stockDashboard = lazy(()=>import("./Store/StockDashBoard/stockDashBoard"));
//-------------------------End Stock Dashboard-------------------------------------------//
//---------------------Expiry Dashboard---------------------------------------------------//
const ExpiryDashBoard  = lazy(()=>import("./Store/ExpiryDashBoard/ExpiryDashBoard"))
//-------------------End Expiry Dashboard-------------------------------------------------//

//-----------------------Sales Orders-------------------------------------------//
const SalesOrder = lazy(() => import("./Store/SalesOrder/salesOrder"));
//-----------------------End Sales Orders---------------------------------------//

//--------------------------Sales Quotations---------------------------------//
const Quotation = lazy(() => import("./Store/Quotation/salesQuotation"));
//-------------------------End Sales Quotations--------------------------------//

//--------------------------Stock Issues--------------------------------//
const StockIssue = lazy(() => import("./Store/Stock-Issue/stockIssue"));
//-------------------------End Stock Issues---------------------------------//

//---------------- End Stock----------------------------------------------------//

//----------------------Item & Services----------------------------------//

//----------------------Item & Service----------------------------------//
const ItemMaster = lazy(() => import("./Stock/Item_Master/itemMaster"));
//----------------------End Item & Service---------------------------------//

//----------------------Category--------------------------------------------//
const ItemCategory = lazy(() => import("./Stock/Category/category"));
//----------------------End Category-----------------------------------------//

//-----------------------Brand-------------------------------------//
const Brand = lazy(() => import("./Stock/Brand/brand"));
//---------------------End Brand---------------------------------------//

//-----------------------Bin Location-------------------------------------//
const Bin = lazy(() => import("./Stock/Bin/bin"));
//---------------------End Bin Location---------------------------------------//

//-----------------------Colour-------------------------------------//
const Colour = lazy(() => import("./Stock/Colour/colour"));
//---------------------End Colour---------------------------------------//

//-----------------------Unit-------------------------------------//
const Unit = lazy(() => import("./Stock/Unit/unit"));
//---------------------End Unit---------------------------------------//

//------------------ Size ----------------------------------------------//
const Size = lazy(()=> import("./Stock/Size/size"))
//------------------End Size---------------------------------------------//

//----------------------End Item & Services---------------------------------//

//-------------------------Customers-----------------------------------//

//-------------------------Customer-----------------------------------//
const Customer = lazy(() => import("./Customer/customer"));
//-------------------------End Customer-------------------------------//

//------------------Doctor master--------------------------------------//
const Doctormaster = lazy(()=>import("./DoctorMaster/DoctorMaster"))
//----------------End Doctor master-------------------------------------//

//-------------------------Payment Receipt-----------------------------------//
const PaymentReceipt = lazy(() =>
  import("./Customer/Payment-receipt/paymentReceipt")
);
//-------------------------End Payment Receipt-------------------------------//

//-------------------------Sales Return----------------------------------------------//
const SalesReturn = lazy(() => import("./Customer/SalesReturn/salesReturn"));
//-------------------------End Sales Return----------------------------------------//

//-------------------------End Customers-------------------------------//


//-----------------------------Cheque Receipts---------------------------//

//-----------------------------Third party Cheque---------------------------//
const ThirdPartyCheque = lazy(()=>(import("./Cheque/ThirdpartyCheque")));
//------------------------End Third party Cheque----------------------------//

//-----------------------------Cheque in hand---------------------------//
const Cheques = lazy(() => import("./Cheque/chequeInHand"));
//------------------------End Cheque in hand----------------------------//

//-----------------------------Cheque in Deposit---------------------------//
const ProcessingCheques = lazy(() => import("./Cheque/ChequeDeposit"));
//------------------------End Cheque in Deposit----------------------------//

//-----------------------------Realized Cheque---------------------------//
const ChequeRealized = lazy(() => import("./Cheque/ChequRealized"));
//------------------------End Realized Cheque----------------------------//

//-----------------------------Returned Cheques---------------------------//
const ReturnedCheques = lazy(() => import("./Cheque/returnedCheques"));
//------------------------End Returned Cheques----------------------------//

//------------------------End Cheque Receipts----------------------------//


//-----------------------Return Cheque Pay-----------------------------//

//----------------------Cheque Receipt----------------------------------------------------------------//
const ReturnChequePayment = lazy(() => import("./Cheque/ReturnChequePayment/ReturnChequePayment"));
//-----------------------End Cheque Receipt---------------------------------------------------------------//

//----------------------End Return Cheque Pay---------------------------//


//--------------------------Suppliers----------------------------------//

//--------------------------Suppliers----------------------------------//
const Suppliers = lazy(() => import("./Suppliers/Supplier/suppliers"));
//--------------------------End Suppliers-------------------------------//

//--------------------------Payment Vouchers----------------------------------//
const PaymentVouchers = lazy(() =>
  import("./Suppliers/PaymentVouchers/paymentVouchers")
);
//--------------------------End Payment Vouchers-------------------------------//

//--------------------------Purchase Return----------------------------------//
const PurchaseReturn = lazy(() =>
  import("./Suppliers/PurchaseReturn/purchaseReturn")
);
//--------------------------End Purchase Return-------------------------------//

//--------------------------End Suppliers-------------------------------//


//-----------------------------Cheque Vouchers-------------------------//

//-----------------------------Cheques in hand-------------------------------------------//
const ChequeVoucher = lazy(() => import("./ChequeVoucher/chequeInHand"));
//---------------------------End Cheques in hand-------------------------------------//

//-----------------------------Cheques in Process-----------------------------------------------//
const ChequeVoucherInProcess = lazy(() => import("./ChequeVoucher/chequesInProcess"));
//---------------------------End Cheques in Process-----------------------------------------//

//-----------------------------Returned Cheques----------------------------------------------//
const ReturnedChequeVoucher = lazy(() => import("./ChequeVoucher/returnedCheques"));
//---------------------------End Returned Cheques-------------------------------------------//

//---------------------------End Cheque Vouchers-------------------------//


//--------------------------Sales Rep--------------------------------------//

//--------------------------Sales Rep--------------------------------------//
const SalesRep = lazy(() => import("./SalesRep/salesRep"));
//-------------------------End Sales Rep-------------------------------//

//-------------------------Medical Rep-----------------------------------//
const MedicalRep = lazy(()=>import("./MedicalRep/MedicaRep"))
//--------------------End Of Medical Rep---------------------------------------------//

//---------------------------Route--------------------------------------//
const Route = lazy(() => import("./SalesRep/Route/route"));
//---------------------------End Route--------------------------------//

//-------------------------End Sales Rep-------------------------------//


//---------------------Reversal----------------------------------------//
const Reversal = lazy(() => import("./Reversal/reversal"));
//----------------------End Reversal----------------------------------//


//---------------------Report----------------------------------------//
const Reports = lazy(() => import("./Reports/reports"));
//----------------------End Report----------------------------------//


//---------------------Barcode----------------------------------------//
const Barcode = lazy(() => import("./Barcode/barcode"));
//----------------------End Barcode----------------------------------//


//------------------------Expenses----------------------------------//

//------------------------Expenses----------------------------------//
const Expenses = lazy(() => import("./Expenses/expenses"));
//---------------------------End Expenses---------------------------//

//------------------------Expenses Categories-------------------------------------------------------//
const ExpansesCategory = lazy(()=>import("./Expenses/ExpensesCategory/expensesCategory"));
//---------------------------End Expenses Categories----------------------------------------//

//---------------------------End Expenses---------------------------//


//---------------------Accounts-----------------------------------------//

//---------------------Credit/Debit----------------------------------------------------------------//
const CreditAndDebit = lazy(() => import("./AccountDetails/CreditAndDebit/CreditAndDebit"));
//-----------------------End Credit/Debit--------------------------------------------------------------//

//---------------------Journal Type------------------------------------------------------------------//
const EntryTypesAccount = lazy(() => import("./AccountDetails/JounralTypesAccount/JournalTypes"));
//-----------------------End Journal Type---------------------------------------------------------------//

//--------------------- General Ledger----------------------------------------------------------------------//
const GenerateGeneralLedger =lazy(()=> import("./AccountDetails/GeneralLedger/GeneralLedger"));
//-----------------------End  General Ledger-----------------------------------------------------//

//-----------------------End Accounts----------------------------------//


//---------------------Stock Freeze-----------------------------------------//
const StockFreeze = lazy(()=>(import("./StockFreeze/stockFreeze")));
//-----------------------End Stock Freeze----------------------------------//



// const ExpensesType = lazy(() => import("./Expenses/ExpensesCategory/expensesCategory"));

const Settings = lazy(() => import("./Settings/settings"));
const Users = lazy(() => import("./Users/users"));
const UserType = lazy(() => import("./Users/User-Type/userType"));
//const Sales = lazy(() => import("./Sales/POS/salesWithPackSize"));
//const InvoiceReversal = lazy(() => import("./InvoiceReversal/Reversal"))



const UpComingServices = lazy(() => import("./Vehicle/upCommingServices"));
const Vehicle = lazy(() => import("./Vehicle/Vehicle"));
const ServicePack = lazy(() =>
  import("./Vehicle/Service-packages/servicePackages")
);
//const stockFreeze = lazy(()=> import("./StockFreeze/stockFreeze"));


//Reports Routing
const SupplierListReport = lazy(() =>import("./Reports/ReportsComponents/Supplier/supplierList"));
const DebitStatement = lazy(() =>import("./Reports/ReportsComponents/Supplier/debitStatement"));
const SupplierSummery = lazy(() =>import("./Reports/ReportsComponents/Supplier/SupplierSummery"));
const PeriodicVoucher = lazy(() =>import("./Reports/ReportsComponents/Supplier/PeriodicVoucher"));
const paymentVoucher = lazy(() =>import("./Reports/ReportsComponents/Supplier/DailyVoucherByPaymentType"));

const PurchaseList = lazy(() =>import("./Reports/ReportsComponents/Purchase/purchaseList"));
const DailyPurchase = lazy(() =>import("./Reports/ReportsComponents/Purchase/dailyPurchase"));
const DetailPurchase = lazy(() =>import("./Reports/ReportsComponents/Purchase/detailsPurchase"));
const MonthlyPurchase = lazy(() =>import("./Reports/ReportsComponents/Purchase/monthlyPurchase"));

const StockInHand = lazy(() =>import("./Reports/ReportsComponents/Stock/stockInhand"));
const StockAudit = lazy(() =>import("./Reports/ReportsComponents/Stock/stockAudit"));
const ItemInStock = lazy(() =>import("./Reports/ReportsComponents/Stock/itemInStock"));
const PeriodicStock = lazy(() =>import("./Reports/ReportsComponents/Stock/periodicStock"));
const StockIssues = lazy(() =>import("./Reports/ReportsComponents/Stock/stockIssue"));
const StockInHandQuantity = lazy(() =>import("./Reports/ReportsComponents/Stock/totalQuantity"));

const DailySummary = lazy(() =>import("./Reports/ReportsComponents/Summary/dailySummary"));
const MonthlySummary = lazy(() =>import("./Reports/ReportsComponents/Summary/monthlySummary"));
const PeriodicSummary = lazy(() =>import("./Reports/ReportsComponents/Summary/periodicSummary"));
const DayEnd = lazy(() =>import("./Reports/ReportsComponents/Summary/dayEnd"));
const DayEndByUser = lazy(() =>import("./Reports/ReportsComponents/Summary/DayEndByUser"));

const CustomerReport = lazy(() =>import("./Reports/ReportsComponents/Customers/listOfCustomer"));
const CustomerSummary = lazy(() =>import("./Reports/ReportsComponents/Customers/customerSummary"));
const CreditStatement = lazy(() =>import("./Reports/ReportsComponents/Customers/creditStatement"));
const CreditStatementRoute = lazy(() =>import("./Reports/ReportsComponents/Customers/CreditStatmentByRoute"));
const CreditStatementRep = lazy(() =>import("./Reports/ReportsComponents/Customers/CreditStatmentByRep"));

const DailySales = lazy(() =>import("./Reports/ReportsComponents/Sales/dailySales"));
const DetailsSales = lazy(() =>import("./Reports/ReportsComponents/Sales/detailsSales"));
const MonthlySales = lazy(() =>import("./Reports/ReportsComponents/Sales/monthlySales"));
const PeriodicSales = lazy(() =>import("./Reports/ReportsComponents/Sales/periodicSales"));
const SalesMargin = lazy(() =>import("./Reports/ReportsComponents/Sales/salesMargin"));
const DailySalesReturn = lazy(() =>import("./Reports/ReportsComponents/Sales/salesReturn"));
const DailySalesWithPayment = lazy(() =>import("./Reports/ReportsComponents/Sales/DailySaleswithPayment"));
const CustomerSalesReconsalation = lazy(() =>import("./Reports/ReportsComponents/Sales/CustomerReconciliation"));
const DeliverSales = lazy(()=>import("./Reports/ReportsComponents/Sales/DelveryList"))

const DailyExpenses = lazy(() =>import("./Reports/ReportsComponents/Expenses/dailyExpenses"));
const MonthlyExpenses = lazy(() =>import("./Reports/ReportsComponents/Expenses/monthlyExpenses"));
const PeriodicExpenses = lazy(() =>import("./Reports/ReportsComponents/Expenses/periodicExpenses"));

const ChequeByCustomer = lazy(() =>import("./Reports/ReportsComponents/ChequeReceipt/chequeByCustomer"));
const ChePeriodicExpenses = lazy(() =>import("./Reports/ReportsComponents/ChequeReceipt/periodicChequ"));
const DailyCheques = lazy(() =>import("./Reports/ReportsComponents/ChequeReceipt/dailyCheque"));
const ChequeInHand = lazy(() =>import("./Reports/ReportsComponents/ChequeReceipt/ChequeInHand"));
const ChequeDeposited = lazy(() =>import("./Reports/ReportsComponents/ChequeReceipt/ChequeDeposit"));
const ChequeRealize = lazy(() =>import("./Reports/ReportsComponents/ChequeReceipt/ChequeRealized"));
const ChequeReturned = lazy(() =>import("./Reports/ReportsComponents/ChequeReceipt/ChequeRetuned"));

const ChequeBySupplier = lazy(() =>import("./Reports/ReportsComponents/ChequeVoucher/chequeBySupplier"));
// const ChePeriodicCheque = lazy(() =>import("./Reports/ReportsComponents/ChequeVoucher/c"));
const DailyChequeVoucher = lazy(() =>import("./Reports/ReportsComponents/ChequeVoucher/dailyCheque"));

const DailyPaymentReceipt = lazy(() =>import("./Reports/ReportsComponents/PaymentReceipt/dailyPaymentReceipt"));
const PaymentReceiptByRep = lazy(() =>import("./Reports/ReportsComponents/PaymentReceipt/paymentReceiptByRep"));
const PaymentReceiptByRoute = lazy(() =>import("./Reports/ReportsComponents/PaymentReceipt/paymentReceiptByRoute"));
const PaymentReceiptByLocation = lazy(() =>import("./Reports/ReportsComponents/PaymentReceipt/paymentReceiptByLocation"));
// const PayChequeReturned = lazy(() =>import("./Reports/ReportsComponents/PaymentReceipt/"));
const ListOfInvoice = lazy(()=>import("./Sales/POS/ListOfInvoice"));
const ListOfSavedInvoice = lazy(()=>import('./Sales/POS/ListOfSavedInvoice'))

//End of reports routing 

export const cashierRouteConfig = {
  settings: {},
  auth: ["superadmin","admin","boss","cashier","1","2","3","4","5" ],
  routes: [
    // { path: "/auto-logout", component: AutoLogout },
    { path: "/customer", component: Customer },
    {path:"/list-of-invoice",component:ListOfInvoice},
    {path:'/list-of-saved-invoice',component:ListOfSavedInvoice},
    {path:"/doctor-master", component:Doctormaster},
    { path: "/matureStock", component: matureStock },
    { path: "/grn", component: Grn },
    { path: "/stock-issue", component: StockIssue },
    { path: "/stock-transfer", component: Transfer },
    { path:"/stock-in", component: StockIn },
    { path: "/sales-auto-care", component: SalesForAutoCare },
    { path: "/barcode", component: Barcode },
    { path: "/service-pack", component: ServicePack },
    { path: "/vehicle", component: Vehicle },
    { path: "/upcoming-service", component: UpComingServices },
    { path:"/stock-dashboard" , component:stockDashboard},
    {path:"/expiry-dashboard",component:ExpiryDashBoard},
    { path: "/sales-quotation", component: Quotation },
    { path: "/suppliers", component: Suppliers },
    { path: "/supplier-list", component: SupplierListReport },
    {path:"/delivery", component:Delivery },
    {path: "/sales-for-warehouse",component: SalesForwareHouse},
   

    // { path: "/auto-logout", component: AutoLogout },
    { path: "/dashboard", component: Dashboard },
    { path: "/sales", component: Sales },
    { path: "/channelling", component: Channelling },
    { path: "/list-of-channelling", component: listOfChannelling },
    // ---------------------------Stock--------------------------------
    // ---------------------------Stock - GRN--------------------------------


    //{ path: "/invoice-reversal", component: InvoiceReversal },
    { path: "/cheques", component: Cheques },
    {path:"/third-party-cheque" , component:ThirdPartyCheque},
    { path: "/returned-cheque", component: ReturnedCheques },
    { path: "/cheques-process", component: ProcessingCheques },
    { path: "/sales-order", component: SalesOrder },
    { path: "/salesRep", component: SalesRep },
    { path: "/medical-rep", component: MedicalRep },
    { path: "/expenses", component: Expenses },
    // { path: "/expenses-type", component: ExpensesType },
    { path: "/expanses-category", component:ExpansesCategory},
    { path: "/credit-and-debit", component: CreditAndDebit },
    { path: "/journal-types", component: JournalTypes },
    { path: "/general-ledger", component: GeneralLedger },
    { path: "/item-master", component: ItemMaster },
    { path: "/item-category", component: ItemCategory },
    { path: "/user", component: Users },
    { path: "/user-type", component: UserType },
    { path: "/sales-return", component: SalesReturn },
    { path: "/reversal", component: Reversal },
    { path: "/payment-vouchers", component: PaymentVouchers },
    { path: "/route", component: Route },
    { path: "/item-bin", component: Bin },
    { path: "/item-colour", component: Colour },
    { path: "/item-brand", component: Brand },
    { path: "/item-unit", component: Unit },
    {path:"/item-size",component:Size},
    // { path: "/grn", component: Grn },
    { path: "/grn-paid", component: PaidGrn },
    { path: "/chequePayment", component: ReturnChequePayment },  
    { path: "/settings", component: Settings },
    { path: "/purchase-return", component: PurchaseReturn },
    { path: "/cheque-vouchers", component: ChequeVoucher },
    { path: "/cheque-vouchers-process", component: ChequeVoucherInProcess },
    { path: "/returned-cheque-vouchers", component: ReturnedChequeVoucher },
    { path:"/cheque-realized", component: ChequeRealized },
    { path: "/payment-receipt", component: PaymentReceipt },
    { path: "/reports/supplier-list", component: SupplierListReport },
    {path:"/stock-freeze", component:StockFreeze},


    {path:"/reports" , component:Reports},

// ---------------------------For Report - Supplier--------------------------------
    { path: "/supplier-list", component: SupplierListReport },
    { path: "/debit-statement", component: DebitStatement },
    { path: "/supplier-summery", component: SupplierSummery },
    { path: "/periodic-voucher", component: PeriodicVoucher },
    { path: "/payment-voucher", component: paymentVoucher },

// ---------------------------For Report - Purchase--------------------------------
    { path: "/purchase-list", component: PurchaseList },
    { path: "/daily-purchase", component: DailyPurchase },
    { path: "/detail-purchase", component: DetailPurchase },
    { path: "/monthly-purchase", component: MonthlyPurchase },

// ---------------------------For Report - Stock--------------------------------
    { path: "/stock-in-hand", component: StockInHand },
    { path: "/stock-audit", component: StockAudit },
    { path: "/item-in-stock", component: ItemInStock },
    { path: "/periodic-stock", component: PeriodicStock },
    { path: "/stock-issues", component: StockIssues },
    { path: "/stock-in-hand-quantity", component: StockInHandQuantity },


// ---------------------------For Report - Summary--------------------------------
    { path: "/daily-summary", component: DailySummary },
    { path: "/monthly-summary", component: MonthlySummary },
    { path: "/periodic-summary", component: PeriodicSummary },
    { path: "/day-end", component: DayEnd },
    { path: "/day-end-by-user", component: DayEndByUser },

// ---------------------------For Report - Customer--------------------------------
    { path: "/customer-report", component: CustomerReport },
    { path: "/customer-summary", component: CustomerSummary },
    { path: "/credit-statement", component: CreditStatement },
    { path: "/credit-statement-route", component: CreditStatementRoute },
    { path: "/credit-statement-rep", component: CreditStatementRep },

// ---------------------------For Report - Sales--------------------------------
    { path: "/daily-sales", component: DailySales },
    { path: "/details-sales", component: DetailsSales },
    { path: "/monthly-sales", component: MonthlySales },
    { path: "/periodic-sales", component: PeriodicSales },
    { path: "/sales-margin", component: SalesMargin },
    { path: "/daily-sales-return", component: DailySalesReturn },
    { path: "/daily-sales-with-payment", component: DailySalesWithPayment },
    { path: "/customer-sales-reconsalation", component: CustomerSalesReconsalation },
    {path: "/delivery-list" , component:DeliverSales},

 // ---------------------------For Report - Expenses--------------------------------
    { path: "/daily-expenses", component: DailyExpenses },
    { path: "/monthly-expenses", component: MonthlyExpenses },
    { path: "/periodic-expenses", component: PeriodicExpenses },
    
 // ---------------------------For Report - Cheque:Reciept--------------------------------
    { path: "/cheque-by-customer", component: ChequeByCustomer },
    { path: "/che-periodic-expenses", component: ChePeriodicExpenses },
    { path: "/daily-cheques", component: DailyCheques },   
    { path: "/cheque-in-hand", component: ChequeInHand },
    { path: "/cheque-deposited", component: ChequeDeposited },
    { path: "/cheque-realize", component: ChequeRealize },
    { path: "/cheque-returned", component: ChequeReturned },

// ---------------------------For Report - Cheque:Voucher--------------------------------
    { path: "/cheque-by-supplier", component: ChequeBySupplier },
    { path: "/che-periodic-expenses", component: ChePeriodicExpenses },
    { path: "/daily-cheque-voucher", component: DailyChequeVoucher },   

// ---------------------------For Report - PaymentReceipt--------------------------------
    { path: "/daily-payment-receipt", component: DailyPaymentReceipt },
    { path: "/payment-receipt-by-rep", component: PaymentReceiptByRep },
    { path: "/payment-receipt-by-route", component: PaymentReceiptByRoute },   
    { path: "/payment-receipt-by-location", component: PaymentReceiptByLocation },
    { path: "/cheque-returned", component: ChequeReturned },   
    


  ],
};

export const authorisedRouteConfig = {
  settings: {},
  auth: [],
  routes: [
    


  ],
};